import { render, staticRenderFns } from "./FooterActions.vue?vue&type=template&id=547fd179&scoped=true&"
import script from "./FooterActions.vue?vue&type=script&lang=js&"
export * from "./FooterActions.vue?vue&type=script&lang=js&"
import style0 from "./FooterActions.vue?vue&type=style&index=0&id=547fd179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fd179",
  null
  
)

export default component.exports